import { defineMessages } from 'react-intl';

export default defineMessages({
    useExistingContact: {
        id: 'CPMIpolicycommon.directives.schedules.contact.Use existing contact?',
        defaultMessage: 'Use existing contact?',
    },
    existingContact: {
        id: 'CPMIpolicycommon.directives.schedules.contact.Existing Contact',
        defaultMessage: 'Existing Contact',
    },
    newContact: {
        id: 'CPMIpolicycommon.directives.schedules.contact.New Contact',
        defaultMessage: 'New Contact',
    }
});
